/**
 * Pages Routes
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Route, Routes, Navigate } from 'react-router-dom';

import PracticeSchedule from 'Routes/golf/practiceschedule';
import PracticeDrill from 'Routes/golf/practicedrill';
import TournamentList from 'Routes/golf/tournamentlist';
import TournamentProcess from 'Routes/golf/tournamentprocess';
import TournamentProcessReport from 'Routes/golf/tourprocessreport';
import PlayerIntervention from 'Routes/golf/playerintervention';
import FSIrons from 'Routes/golf/technologyreport/fsirons'; // fixed name
import FSDriver from 'Routes/golf/technologyreport/fsdriver';
import WedgePlay from 'Routes/golf/technologyreport/wedgeplay';
import SamLabReport from 'Routes/golf/technologyreport/samlabreport';
import CaptoReport from 'Routes/golf/technologyreport/captoputtingreport';
import LaunchReport from 'Routes/golf/technologyreport/launchmonitorreport';
import HackmotionReport from 'Routes/golf/technologyreport/hackmotion';
import SpeedCheck from 'Routes/golf/technologyreport/speedcheck';
import CourseIntervention from 'Routes/golf/courseintervention';
import RangePutting from 'Routes/golf/rangeintervention/putting';
import RangeLongGame from 'Routes/golf/rangeintervention/longgame';
import RangeShortGame from 'Routes/golf/rangeintervention/shortgame';

import OCBunkerPlay from 'Routes/golf/oncoursetest/bunkerplay';
import OCWedgePlay from 'Routes/golf/oncoursetest/wedgeplay';
import OCShortGame from 'Routes/golf/oncoursetest/shortgame';
import OCApproach from 'Routes/golf/oncoursetest/approach';
import OCDriving from 'Routes/golf/oncoursetest/driving';
import OCChartView from 'Routes/golf/oncoursetest/oncoursechart';
import NineEightHole from 'Routes/golf/oncoursetest/nineeighthole';
import ONScoringReport from 'Routes/golf/oncoursetest/onscoringreport';

import ORChipping from 'Routes/golf/onrangetest/chipping';
import ORBunker from 'Routes/golf/onrangetest/bunker';
import ORWedge from 'Routes/golf/onrangetest/wedgeplay';
import ORShortGame from 'Routes/golf/onrangetest/shortgame';
import ORIron from 'Routes/golf/onrangetest/iron';
import ORDriving from 'Routes/golf/onrangetest/driving';
import ORLongGame from 'Routes/golf/onrangetest/longgame';
import ORChartView from 'Routes/golf/onrangetest/onrangereport';

import PuttPerformance from 'Routes/golf/putt/puttperformance';
import FiveBroadie from 'Routes/golf/putt/broadiedrill5';
import TenBroadie from 'Routes/golf/putt/broadiedrill10';
import FifteenBroadie from 'Routes/golf/putt/broadiedrill15';
import HundredBroadie from 'Routes/golf/putt/broadiedrill100';
import PuttReport from 'Routes/golf/putt/puttchart';

import TournamentScore from 'Routes/golf/tournamentscore';
import TournamentReport from 'Routes/golf/tournamentreport';

// app config
import AppConfig from 'Constants/AppConfig';

const Pages = () => (
  <div className="content-wrapper">
    <Helmet>
      <title>Golf | {AppConfig.appTitle}</title>
      <meta name="description" content="TSGA Golf" />
    </Helmet>
    <Routes>
      {/* Default redirect */}
      <Route index element={<Navigate to="practiceschedule" replace />} />

      <Route path="practiceschedule" element={<PracticeSchedule />} />
      <Route path="practicedrill" element={<PracticeDrill />} />
      <Route path="tournamentlist" element={<TournamentList />} />
      <Route path="tournamentprocess" element={<TournamentProcess />} />
      <Route path="playerintervention" element={<PlayerIntervention />} />
      <Route path="technologyreport/fsirons" element={<FSIrons />} />
      <Route path="technologyreport/fsdriver" element={<FSDriver />} />
      <Route path="technologyreport/wedgeplay" element={<WedgePlay />} />

      <Route path="tournamentscore" element={<TournamentScore />} />
      <Route path="tournamentreport" element={<TournamentReport />} />
      <Route path="tournamentprocessreport" element={<TournamentProcessReport />} />

      <Route path="technologyreport/samlabreport" element={<SamLabReport />} />
      <Route path="technologyreport/captoreport" element={<CaptoReport />} />
      <Route path="technologyreport/launchreport" element={<LaunchReport />} />
      <Route path="technologyreport/hackmotion" element={<HackmotionReport />} />
      <Route path="technologyreport/speedcheck" element={<SpeedCheck />} />
      <Route path="courseintervention" element={<CourseIntervention />} />
      <Route path="rangeintervention/putting" element={<RangePutting />} />
      <Route path="rangeintervention/longgame" element={<RangeLongGame />} />
      <Route path="rangeintervention/shortgame" element={<RangeShortGame />} />

      <Route path="oncoursetest/ocbunkerplay" element={<OCBunkerPlay />} />
      <Route path="oncoursetest/ocwedgeplay" element={<OCWedgePlay />} />
      <Route path="oncoursetest/ocshortgame" element={<OCShortGame />} />
      <Route path="oncoursetest/ocapproach" element={<OCApproach />} />
      <Route path="oncoursetest/ocdriving" element={<OCDriving />} />
      <Route path="oncoursetest/occhartview" element={<OCChartView />} />
      <Route path="oncoursetest/nineeighthole" element={<NineEightHole />} />
      <Route path="oncoursetest/onscoringreport" element={<ONScoringReport />} />

      <Route path="onrangetest/orchipping" element={<ORChipping />} />
      <Route path="onrangetest/orbunker" element={<ORBunker />} />
      <Route path="onrangetest/orwedgeplay" element={<ORWedge />} />
      <Route path="onrangetest/orshortgame" element={<ORShortGame />} />
      <Route path="onrangetest/oriron" element={<ORIron />} />
      <Route path="onrangetest/ordriving" element={<ORDriving />} />
      <Route path="onrangetest/orlonggame" element={<ORLongGame />} />
      <Route path="onrangetest/orchartview" element={<ORChartView />} />

      <Route path="putt/puttperformance" element={<PuttPerformance />} />
      <Route path="putt/broadiedrillfive" element={<FiveBroadie />} />
      <Route path="putt/broadiedrillten" element={<TenBroadie />} />
      <Route path="putt/broadiedrillfifteen" element={<FifteenBroadie />} />
      <Route path="putt/broadiedrillhundred" element={<HundredBroadie />} />
      <Route path="putt/puttperformancereport" element={<PuttReport />} />
    </Routes>
  </div>
);

export default Pages;
